import { Component, Input, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';

@Component({
    selector: 'quiz',
    templateUrl: './quiz.component.html',
    styleUrls: ['./quiz.component.scss'],
    providers: [],
    standalone: false
})

export class QuizComponent implements OnInit {
  @Input() dynamicContent: Models.DynamicContent;
  @Input() parent: Models.DynamicContentEntrance;
  @Input() create: any;

  answers = [];
  isMain = false;
  entranceConfig: any;

  constructor(private entranceService: DynamicContentEntranceService) {
  }

  ngOnInit() {
    this.isMain = this.parent instanceof Models.DynamicContentEntrance;
    if (!this.isMain) {
      this.entranceService.find(0, 1, { children: this.parent._id }).then(res => {
        if (res && res.data && res.data[0] && res.data[0].config) {
          this.entranceConfig = res.data[0].config;
        }
      });
    }
  }

  addAnswer(event: any) {
    if (event.target.value !== '') {
      if (!this.dynamicContent.content.answers) {
        this.dynamicContent.content.answers = [];
      }
      const answer = new Models.ContentQuizAnswer();
      answer.populateFromJSON({ title: event.target.value });
      this.dynamicContent.content.answers.push(answer);
      event.target.value = '';
    }
  }

  removeAnswer(index: number) {
    this.dynamicContent.content.answers.splice(index, 1);
  }

  dropAnswer(event: any) {
    const movingElement = this.dynamicContent.content.answers.splice(event.previousIndex, 1)[0];
    this.dynamicContent.content.answers.splice(event.currentIndex, 0, movingElement);
  }

  getCorrectAnswerCount() {
    return this.dynamicContent.content.answers.filter(answer => { return answer.isCorrect }).length;
  }

  maxAnswersReached() {
    return this.entranceConfig?.maxAnswers && this.dynamicContent?.content?.answers?.length >= this.entranceConfig.maxAnswers;
  }
}
